import { useCallback, useEffect, useState } from 'react'

// eslint-disable-next-line no-unused-vars
import { IData, ITable, IColumn } from '../interfaces/table'

interface IUseTable extends ITable {
  isSearching: () => boolean
}

export const useTable = (props: IUseTable) => {
  const [currentColumns, setCurrentColumns] = useState<string[]>([])

  const [currentData, setCurrentData] = useState<IData>([])

  const [data, setData] = useState<IData>([])

  const settingData = useCallback(() => {
    setData(props.data)
  }, [props.data])

  useEffect(() => {
    settingData()
  }, [settingData])

  const settingCurrentData = useCallback(() => {
    setCurrentData(data)
  }, [data])

  useEffect(() => {
    settingCurrentData()
  }, [settingCurrentData])

  const [columns, setColumns] = useState<IColumn[]>([])

  const settingColumns = useCallback(() => {
    setColumns(props.columns)
  }, [props.columns])

  useEffect(() => {
    settingColumns()
  }, [settingColumns])

  const settingCurrentColumns = useCallback(() => {
    const serializedCurrentColumns = columns.map((column) => column.data)

    setCurrentColumns(serializedCurrentColumns)
  }, [columns])

  useEffect(() => {
    settingCurrentColumns()
  }, [settingCurrentColumns])

  return {
    data,
    columns,
    currentColumns,
    setCurrentColumns,
    currentData,
    setCurrentData
  }
}
